(function(){
    'use strict';
    angular.module('Directives').directive('bbaDefaultImageLoader', bbaImageLoader);
    bbaImageLoader.$inject = ['$http'];

    function bbaImageLoader($http){
        return {
            restrict: 'A',
            link: function(scope, element, attrs){
                element.bind('error', function(){
                   element.attr('src', '/images/default_avatar.png');
                });
            }
        }
    }
})();


// WEBPACK FOOTER //
// ./js/directives/bbaDefaultImageLoader.js